import Multi from '@cdo/apps/code-studio/levels/multi';
window.Multi = Multi;
